// Config for the dedicated Skills Programs landing pages under /offerings/:slug
// catKeys maps each program to the matching COURSES catKey(s) in mock.js so the
// page can list real courses; leave empty to show the generic "coming soon" copy.

export const CATEGORY_PAGES = {
  "genai": {
    label: "GenAI",
    eyebrow: "SKILLS PROGRAM",
    title: "Generative AI Programs",
    subtitle: "Build production-grade LLM applications, AI agents and prompt engineering skills with hands-on, enterprise-ready training.",
    catKeys: ["ai"]
  },
  "data-analytics-ai": {
    label: "Data, Analytics & AI",
    eyebrow: "SKILLS PROGRAM",
    title: "Data, Analytics & AI Programs",
    subtitle: "From data science fundamentals to big data and enterprise BI — turn your teams into data-driven decision makers.",
    catKeys: ["data"]
  },
  "cloud-devops": {
    label: "Cloud & DevOps",
    eyebrow: "SKILLS PROGRAM",
    title: "Cloud & DevOps Programs",
    subtitle: "Certify your engineers on AWS, Azure, GCP, Kubernetes and modern CI/CD practices.",
    catKeys: ["cloud", "devops"]
  },
  "cybersecurity": {
    label: "Cybersecurity",
    eyebrow: "SKILLS PROGRAM",
    title: "Cybersecurity Programs",
    subtitle: "Ethical hacking, cloud security, penetration testing and SOC readiness for enterprise security teams.",
    catKeys: ["security"]
  },
  "software-engineering": {
    label: "Software Engineering",
    eyebrow: "SKILLS PROGRAM",
    title: "Software Engineering Programs",
    subtitle: "Full-stack development, modern frameworks and system design skills for high-performing engineering teams.",
    catKeys: ["dev"]
  },
  "applications-platforms": {
    label: "Applications & Platforms",
    eyebrow: "SKILLS PROGRAM",
    title: "Applications & Platforms Programs",
    subtitle: "Enterprise application and platform engineering skills across cloud-native and vendor ecosystems.",
    catKeys: ["dev", "cloud"]
  },
  "testing": {
    label: "Testing",
    eyebrow: "SKILLS PROGRAM",
    title: "Testing Programs",
    subtitle: "Manual, automation and performance testing skills to ship reliable software faster.",
    catKeys: []
  },
  "methodologies-frameworks": {
    label: "Methodologies & Frameworks",
    eyebrow: "SKILLS PROGRAM",
    title: "Methodologies & Frameworks Programs",
    subtitle: "Agile, Scrum, SAFe and project management frameworks to run high-performing delivery teams.",
    catKeys: ["agile"]
  },
  "soft-skills": {
    label: "Soft-Skills",
    eyebrow: "SKILLS PROGRAM",
    title: "Soft-Skills Programs",
    subtitle: "Leadership, communication and collaboration skills that complement technical training.",
    catKeys: ["business"]
  }
};
